import React from "react"
import "./btn-burger.scss"
export default function BtnBurger({ isOpen = false, onClick = () => {} }) {
  return (
    <div className="btn-burger" onClick={onClick}>
      <div className={isOpen ? "menu-burguer open" : "menu-burguer"}>
        <div className="menu-line" />
        <div className="menu-line" />
        <div className="menu-line" />
      </div>
    </div>
  )
}
